import { gql } from "@apollo/client";
import { graph } from "config/axios-context";
import { DeleteFruitMutation, DeleteFruitMutationVariables, FruitFilterInput } from "types/graphql";

export const deleteFruitMutation = gql`
mutation DeleteFruit($id: Int, $where: FruitFilterInput) {
    fruitDelete(id:$id, where:$where) 
}
`;

export async function deleteFruit(condition: Number | FruitFilterInput) {
    var response = await graph<DeleteFruitMutation, DeleteFruitMutationVariables>({
        query: deleteFruitMutation,
        variables: {
            id: typeof condition == 'number' ? condition : undefined,
            where: (typeof condition == 'object' ? condition : undefined) as FruitFilterInput | undefined
        }
    });

    if(response.errors?.length) throw response.errors;

    return response.data?.fruitDelete;
}
